import { currencyConfig } from './currency.config';
import { roles } from './permissions.config';
import { reasonCodesConfig } from './reasonCodes.config';
import { menuConfig } from './menu.config';
const config = {
    title: '',
    language: 'en',
    languages: ['en', 'ru'],
    langs: [
        {
            value: 'en',
            label: 'English',
            iconKey: 'GB'
        },
        {
            value: 'ru',
            label: 'Русский',
            iconKey: 'RU'
        }
    ],
    defaultSort: {
        field: 'id',
        direction: 'desc'
    },
    reasonCodes: reasonCodesConfig,
    currencies: currencyConfig,
    roles: roles, // object with roles
    serverHost: 'http://localhost:3000',
    menu: menuConfig
};

export default config;
